import * as React from "react";

export const IconBan = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 10.08 4.68 8.32 5.81 6.93L17.07 18.19C15.68 19.32 13.92 20 12 20ZM18.19 17.07L6.93 5.81C8.32 4.68 10.08 4 12 4C16.41 4 20 7.59 20 12C20 13.92 19.32 15.68 18.19 17.07Z"
      fill="currentColor"
    />
  </svg>
);
